import Page from 'src/features/restocking/components/RestockingWebAppForm/components/Page/Page'
import { useBlockPopAction } from 'src/hooks/useBlockPopAction'
import { useSelector } from 'src/utils/store'
import UserIdentifier from 'src/features/restocking/components/RestockingWebAppForm/components/UserIdentifier/UserIdentifier'
import UserGuidance from 'src/features/restocking/components/RestockingWebAppForm/components/UserGuidance/UserGuidance'
import ScanCode from 'src/features/restocking/components/RestockingWebAppForm/components/ScanCode/ScanCode'
import * as S from './RestockEntryCollectAddressPage.styles'
import { useForm } from 'react-hook-form'
import { useEffect, useState } from 'react'
import { Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { actions } from '../../../RestockingState'

const RestockEntryCollectAddressPage: React.FC = () => {
  const {
    register, getValues, setError, clearErrors, formState: { errors },
  } = useForm<{ address: string }>()

  const { user } = useSelector((state) => state.restocking)
  const [data, setData] = useState<{ bagde: string, idPage: number, entryCollectAddressAddress: string | null} | undefined>(undefined)
  const [isDisabled, setDisabled] = useState(false)

  useBlockPopAction()

  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    if (user && user.startedPage.itemsToCollect) {
      setData({
        bagde: user.badge,
        idPage: user.startedPage.itemsToCollect.id,
        entryCollectAddressAddress: user.startedPage.itemsToCollect.entryCollectAddress,
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSubmit = () => {
    if (!data) {
      return
    }

    if (isDisabled) {
      return
    }

    setDisabled(true)

    clearErrors('address')

    const address = getValues('address').trim()

    if (!address) {
      setError('address', { message: 'Campo obrigatório' })
      setDisabled(false)
      return
    }

    dispatch(actions.restockingValidateEntryCollectAddress({
      badge: data.bagde,
      idPage: data.idPage,
      address,
      history,
      setDisabled,
    }))
  }

  return (
    <Page headerTitle='Reposição'>
      {data && (
        <>
          <S.Info>
            <UserIdentifier idPage={data.idPage}/>
            {data.entryCollectAddressAddress && (
            <UserGuidance text='Continue usando o endereço móvel'>
              <Typography style={{ fontWeight: 'bold', fontSize: '30px' }} data-testid='address-test-id'>
                {data.entryCollectAddressAddress}
              </Typography>
            </UserGuidance>
            )}
          </S.Info>
          <S.Form>
            <ScanCode
              text='Bipe o endereço móvel'
              onSubmit={onSubmit}
              register={register}
              dataTestId='input-address-test-id'
              inputName='address'
              hasError={!!errors.address}
              errorMessage={errors.address?.message}
            />
          </S.Form>
        </>
      )}
    </Page>
  )
}

export default RestockEntryCollectAddressPage
